import { graphql } from '../../../../../../graphql';

export const CREATE_ADMISSION_STEP_DATA = graphql(`
  mutation createDSRCAdmission($input: CreateDSRCAdmissionInput!) {
    createDSRCAdmission(input: $input) {
      _id
    }
  }
`);
